<template>
  <div>
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="8">
        <!-- Filtre par mots clés -->
        <div class="d-flex flex-row align-items-center">
          <v-icon class="p-4 icon-hide">fas fa-search</v-icon>
          <v-text-field
            v-model="filters.text"
            hide-details
            solo
            background-color="white"
            autocomplete="off"
            @change="persist"
            style="position: relative; z-index: 2"
            :placeholder="$t('search.placeholder')"
            class="v-text-field_font-size"
          ></v-text-field>
          <img
            style="
              top: -85px;
              left: 60px;
              position: absolute;
              z-index: 1;
              width: 100px;
            "
            src="/media/svg/illustrations/TMG-ours-bras-croises.png"
          />
          <!-- Gestion de l'ordre -->
          <SortingMenu :filters="filters" @sortingParameters="getSorting" />
        </div>
      </v-col>
      <!--filtre par thèmes-->
      <v-col col-xs-12 col-sm-12 col-md-3 col-lg-3>
        <theme-select
          v-on:selection-change="onThemeChange"
          :themeId="parseInt(filters.theme)"
        ></theme-select>
      </v-col>
    </v-row>
    <!--Message en cours de recherche-->
    <v-row v-if="loading === true" class="pt-10 d-flex justify-content-center">
      <div class="d-flex flex-column">
        <!-- <h3 class="d-flex justify-content-center">Genius est en cours de recherche. Patiente un peu...</h3> -->
        <div class="d-flex justify-content-center">
          <img
            style="height: 30vh"
            src="/media/svg/illustrations/TMG_ours-fusee-qui-vole.gif"
          />
        </div>
      </div>
    </v-row>
    <!--Message si aucun resultat-->
    <v-row
      v-else-if="filters.text.length > 0 && videos.length === 0"
      class="pt-10 d-flex justify-content-center"
    >
      <div class="d-flex flex-column justify-content-center">
        <p style="color: #3b3838; text-align: center; line-height: 0.5em">
          {{ $t("wish.noSearchResultsL1") }}
        </p>
        <p style="color: #3b3838; text-align: center; line-height: 0.5em">
          {{ $t("wish.noSearchResultsL2") }}
        </p>
        <FormWish
          class="mt-15"
          mode="VideoList_NoSearchResults"
          :search="filters.text ? filters.text : ''"
          :searchResultNumber="videos ? String(videos.length): '0'"
          video="-1"
          :theme="filters.theme ? String(filters.theme.id) : '-1'"
        />
      </div>
    </v-row>

    <!-- Affichage des vidéos -->
    <template v-else>
      <div
        v-bind:class="{
          'v-cards-videos': filters.theme === null,
          'v-cards-theme': filters.theme !== null,
        }"
      >
        <div v-for="video in videos" :key="video.id">
          <video-card
            v-bind:video="video"
            v-bind:router-link-to="{
              name: 'video',
              params: { id: video.id, video: video },
            }"
          ></video-card>
        </div>
      </div>
      <v-row
        v-if="videos.length > 0"
        class="pt-10 pb-10 d-flex justify-content-center"
      >
        <div class="d-flex flex-column justify-content-center">
          <p style="color: #3b3838; text-align: center; line-height: 0.5em">
            {{ $t("wish.noSatifyingResult") }}
          </p>
          <FormWish
            mode="VideoList_NoSatifyingResult"
            :search="filters.text ? filters.text : ''"
            :searchResultNumber="videos ? String(videos.length) : '0'"
            video="-1"
            :theme="filters.theme ? String(filters.theme.id) : '-1'"
          />
        </div>
      </v-row>
    </template>

    <!-- Pagination -->
    <template v-if="videos.length > 0 && loading === false">
      <div class="text-center">
        <v-pagination
          v-model="pagination.currentPage"
          :length="pagination.pagesNumber"
          @input="onPageChange"
          class="py-5"
        ></v-pagination>
      </div>
    </template>
  </div>
</template>

<style scoped>
@media only screen and (max-width: 721px) {
  .icon-hide {
    display: none !important;
  }
}
</style>

<script>
import Api from "../../core/services/api.service";
import VideoCard from "@/components/video/videoCard";
import ThemeSelect from "@/components/theme/themeSelect";
import FormWish from "@/components/common/formWish";
import SortingMenu from "@/components/common/sortingMenu";

export default {
  name: "videoList",
  components: { ThemeSelect, VideoCard, FormWish, SortingMenu },
  props: {
    showAllByDefault: { type: Boolean, default: false },
    localStorageThemeKey: { type: String, default: "video-list-theme" },
    localStorageTextKey: { type: String, default: "video-list-text" },
  },
  /**********************************
   * DATA
   **********************************/
  data: (instance) => ({
    videos: [],
    sortingParameters: null,
    filters: {
      text: localStorage[instance.localStorageTextKey] ?? "",
      theme: localStorage[instance.localStorageThemeKey] ?? null,
    },
    pagination: {
      currentPage: 1,
      pagesNumber: 0,
    },
    loading: false,
  }),
  /**********************************
   * MOUNTED
   **********************************/
  mounted() {
    if (
      this.showAllByDefault ||
      this.localStorageThemeKey ||
      this.localStorageTextKey
    ) {
      this.getAllVideos();
    }
  },
  /**********************************
   * WATCH
   **********************************/
  watch: {
    filters: {
      handler() {
        this.onVideoParametersChange();
      },
      deep: true,
    },
  },
  /**********************************
   * METHODS
   **********************************/
  methods: {
    getSorting(sortingParameters){
      // Vérification si changement de paramètres 
      this.sortingParameters = sortingParameters;
      this.onVideoParametersChange();
    },
    getAllVideos() {
      // Si aucun filtre 
      if ( !this.showAllByDefault && this.filters.theme === null && this.filters.text.length === 0) {
        this.videos = [];
        this.loading = false;
        return;
      } 
      
      // Gestion des mots-clés / recherches
      const searchWords = this.filters.text.toLowerCase().split(" ").filter((w) => w !== " ");
      let params = {
        page: this.pagination.currentPage,
        // TODO: Ajouter un filtre pour ne pas récupérer les vidéos non visibles
        //videos: this.videos.filter(v => v.isVisible === true)
      };
      if (searchWords.length > 0 && searchWords[0] !== "") {
        params["keywords"] = searchWords.join(",");
      }

      // Gestion de l'ordre
      let orderType =  this.sortingParameters!= null && this.sortingParameters.sortVideoType >= 0 ? this.sortingParameters.sortVideoTypeList[this.sortingParameters.sortVideoType].type : "sort-date";
      let orderDirection = this.sortingParameters!= null && this.sortingParameters.sortVideoDirection >= 0 ? this.sortingParameters.sortVideoDirectionList[this.sortingParameters.sortVideoDirection].direction : "DESC";
      switch (orderType) {
        case "sort-date":
          params["order_date"] = orderDirection;
          break;
        case "sort-alpha":
          params["order_title"] = orderDirection;
          break;
        case "sort-view":
          params["order_views"] = orderDirection;
          break;
      }

      // Gestion des thèmes 
      if (this.filters.theme !== null) {
        params["theme"] = this.filters.theme.id;
      }

      // Récupération des vidéos
      Api.query("videos", { params: params }).then((videos) => {
        this.videos = videos.data["hydra:member"].filter(v => v.isVisible === true);
        this.pagination.pagesNumber = Math.ceil(videos.data["hydra:totalItems"] / 12);
        this.loading = false;
      });
    },

    // Méthode pour gèrer le changement de paramètres sur la sélection des vidéos
    onVideoParametersChange(){
       this.loading = true;
        if (this.timer != null) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.pagination.currentPage = 1;
          this.getAllVideos();
        }, 1000);
    },

    // Changement de la page
    onPageChange() {
      this.getAllVideos();
    },

    // Changement du theme
    onThemeChange(theme) {
      this.filters.theme = theme;
      if (this.filters.theme !== null) {
        localStorage[this.localStorageThemeKey] = this.filters.theme.id;
      } else {
        localStorage.removeItem(this.localStorageThemeKey);
      }
    },
    // Gestion de la persistence
    persist() {
      localStorage[this.localStorageTextKey] = this.filters.text;
    },
  },
};
</script>
